<script lang="ts" setup>
import { provide, toRefs } from 'vue'
import { RadioGroup } from '@headlessui/vue'
import { DTRadioGroupProvider } from '../../keys'

interface Option {
  text: string
  value: any
  disabled?: boolean
}

const props = withDefaults(defineProps<{
  modelValue: any
  options?: Option[]
}>(), {
  options: () => [] as Option[],
})

defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const { modelValue } = toRefs(props)

provide(DTRadioGroupProvider, {
  modelValue,
})
</script>

<template>
  <RadioGroup
    :model-value="modelValue"
    class="divide-y divide-gray-200 rounded-lg border border-gray-200 py-1"
    @update:model-value="val => $emit('update:modelValue', val)"
  >
    <slot>
      <DTRadioGroupOption
        v-for="(opt, index) in options"
        :key="index"
        :value="opt.value"
        :text="opt.text"
        :disabled="opt.disabled"
      />
    </slot>
  </RadioGroup>
</template>
